import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";
import { tokens } from "../../theme/tokens";

const BP = tokens.layout.mobileFirstExpandPx;

export const Body = styled.div`
  padding: 16px;
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Subtitle = styled.p`
  font-size: ${fontSizes.sm}px;
  line-height: 1.5;
  color: var(--color-text-complement);
  margin: 0 0 4px;
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${BP}px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
`;

export const GameCard = styled.button`
  width: 100%;
  text-align: left;
  border: 1px solid #e8eaf0;
  border-radius: 16px;
  padding: 16px;
  background: #fff;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:active {
    transform: scale(0.99);
  }
`;

export const IconWrap = styled.div<{ $bg: string }>`
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: ${(p) => p.$bg};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const GameMeta = styled.div`
  flex: 1;
  min-width: 0;
`;

export const GameTitle = styled.h3`
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-title);
  margin: 0 0 4px;
`;

export const GameDesc = styled.p`
  font-size: ${fontSizes.sm}px;
  line-height: 1.45;
  color: var(--color-text-complement);
  margin: 0 0 8px;
`;

export const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Tag = styled.span`
  font-size: ${fontSizes.sm}px;
  font-weight: var(--font-weight-semibold);
  color: ${TAB_BAR.primary};
  background: ${TAB_BAR.navbarBg};
  padding: 4px 10px;
  border-radius: 8px;
`;
